import { FlexLayout, H4, Icon } from '@deity/falcon-ui';
import type { FC } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavigateToEntityProps {
  linkText: string;
}
export const NavigateToEntity: FC<NavigateToEntityProps> = ({ linkText }) => {
  const { pathname } = useLocation();
  const entityListPath = pathname.split('/');
  entityListPath.pop();

  return (
    <FlexLayout alignItems="center" width="full" height="full">
      <Link to={entityListPath.join('/')} style={{ textDecoration: 'none' }}>
        <FlexLayout alignItems="center">
          <Icon src="arrowBack" color="primaryText" stroke="transparent" />
          <H4 fontWeight="bold" color="primaryText" ml="xs">
            {linkText}
          </H4>
        </FlexLayout>
      </Link>
    </FlexLayout>
  );
};
